module.exports = __webpack_public_path__ + "images/newerp_button1.1789545008192.png";